<template>
  <div>
    <div class="upload-area col-lg-6" id="uploadArea" ref="uploadArea" v-if="dragAndDropCapable">
      <font-awesome-icon icon="cloud-upload-alt" size="3x" class="upload-icon" /> Drag images to upload or
      <input class="choose-file" type="file" ref="inputUpload" @change="addFiles" multiple />
    </div>
    <div id="uploadArea" v-else>
      <input type="file" id="file" name="file" />
    </div>
    <div class="">
      <div class="row mt-5" id="photos">
        <div v-for="(file, key) in existingFiles" class="col-lg-4 file-listing" :key="'existing-' + key">
          <div class="file-wrapper">
            <img
              class="preview img-fluid"
              :ref="'preview' + (parseInt(key, 10) + newFiles.length)"
              :src="`https://alabama-travel.s3.amazonaws.com/partners-uploads/photo/image/${file._id}/${file.image}`"
            />
            <div class="file-content">
              <span><strong>Image Name</strong> <span class="red">*</span></span>
              <b-input v-model="file.image_name" :state="submitted && !file.image_name ? false : null" />
              <b-form-invalid-feedback class="d-block red" v-if="submitted && !file.image_name">Image Name is required</b-form-invalid-feedback>
              <span><strong>Image Description</strong> (for screen readers) <span class="red">*</span></span>
              <b-form-textarea v-model="file.description" :ref="'description' + parseInt(key, 10)" rows="4" max-rows="4" maxlength="150" :state="submitted && !file.description ? false : null" />
              <small class="char-counter">{{ (file.description || '').length }} / 150</small>
              <b-form-invalid-feedback class="d-block red" v-if="submitted && !file.description">Image Description is required</b-form-invalid-feedback>
              <b-form-checkbox v-model="file.featured" @change="setFeaturedImage(file)" ref="featuredCheckbox" name="featured-checkbox"
                >Featured</b-form-checkbox
              >
              <a class="remove" @click="removeExistingFile(key)">Delete Image</a>
            </div>
          </div>
        </div>
        <div v-for="(file, key) in newFiles" class="col-lg-4 file-listing" :key="'new-' + key">
          <div class="file-wrapper">
            <img class="preview img-fluid" :ref="'preview' + parseInt(key, 10)" />
            <div class="file-content">
              <span><strong>Image Name</strong> <span class="red">*</span></span>
              <b-input v-model="file.image_name" :state="submitted && !file.image_name ? false : null" />
              <b-form-invalid-feedback class="d-block red" v-if="submitted && !file.image_name">Image Name is required</b-form-invalid-feedback>
              <span><strong>Image Description</strong> <span class="red">*</span></span>
              <b-form-textarea v-model="file.description" :ref="'description' + parseInt(key, 10)" rows="4" max-rows="4" maxlength="150" :state="submitted && !file.description ? false : null" />
              <small class="char-counter">{{ (file.description || '').length }} / 150</small>
              <b-form-invalid-feedback class="d-block red" v-if="submitted && !file.description">Image Description is required</b-form-invalid-feedback>
              <b-form-checkbox v-model="file.featured" @change="setFeaturedImage(file)" ref="featuredCheckbox" name="featured-checkbox"
                >Featured</b-form-checkbox
              >
              <a class="remove" @click="removeNewFile(key)">Delete Image</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

// Refrain from continued use of this plugin, we are trying to move away from use the photos collection in the DB - use FileInput instead

export default {
  data() {
    return {
      dragAndDropCapable: false,
      existingFiles: [],
      newFiles: [],
      selectedFeaturedImage: null,
      submitted: false,
    };
  },
  props: {
    files: {
      type: Array,
    },
    type: {
      type: String,
      required: true,
    },
    locationId: {
      type: String,
      required: false,
    },
  },
  watch: {
    files() {
      this.existingFiles = this.files;
    },
  },
  mounted() {
    const div = document.createElement('div');
    this.dragAndDropCapable = ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach((evt) => {
        if (this.$refs.uploadArea) {
          this.$refs.uploadArea.addEventListener(
            evt,
            (e) => {
              e.preventDefault();
              e.stopPropagation();
            },
            false
          );
        }
      });
      if (this.$refs.uploadArea) {
        this.$refs.uploadArea.addEventListener('drop', (e) => {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            const droppedFile = e.dataTransfer.files[i];
            this.newFiles.push({
              rawFile: droppedFile,
              name: droppedFile.name,
              type: droppedFile.type,
              image_name: '',
              description: '',
              featured: false,
            });
          }
          this.getImagePreviews();
        });
      }
    }
  },
  methods: {
    validatePhotos() {
      this.submitted = true;
      const allFiles = this.existingFiles.concat(this.newFiles);
      return allFiles.every(f => f.image_name && f.image_name.trim() !== '' && f.description && f.description.trim() !== '');
    },
    setFeaturedImage(file) {
      this.existingFiles.map((x) => {
        x.featured = false;
        return x;
      });
      this.newFiles.map((x) => {
        x.featured = false;
        return x;
      });
      file.featured = true;
      this.$emit('featuredImageChanged', this.newFiles.concat(this.existingFiles));
    },
    addFiles() {
      const fileType = /\b(jpg|jpeg|gif|png)\b/i;
      for (let i = 0; i < this.$refs.inputUpload.files.length; i++) {
        const pickedFile = this.$refs.inputUpload.files[i];
        if (fileType.test(pickedFile.name)) {
          this.newFiles.push({
            rawFile: pickedFile,
            name: pickedFile.name,
            type: pickedFile.type,
            image_name: '',
            description: '',
            featured: false,
          });
        } else {
          this.$bvToast.toast('Please make sure the image(s) you are uploading are jpg, jpeg, png, or gif', {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
        this.getImagePreviews();
      }
    },
    getImagePreviews() {
      for (let i = 0; i < this.newFiles.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.newFiles[i].name)) {
          const reader = new FileReader();

          reader.addEventListener(
            'load',
            () => {
              this.$refs[`preview${parseInt(i, 10)}`][0].src = reader.result;
            },
            false
          );

          reader.readAsDataURL(this.newFiles[i].rawFile);
        } else {
          this.$nextTick(() => {
            this.$refs[`preview${parseInt(i, 10)}`][0].src = '/images/file.png';
          });
        }
      }
    },
    removeNewFile(key) {
      const deletedFile = this.newFiles[key];

      this.newFiles.splice(key, 1);

      if (deletedFile && deletedFile.featured) {
        this.$emit('featuredImageChanged', this.newFiles.concat(this.existingFiles));
      }

      this.getImagePreviews();
    },
    removeExistingFile(key) {
      const deletedFile = this.existingFiles[key];

      this.existingFiles.splice(key, 1);

      if (deletedFile && deletedFile.featured) {
        this.$emit('featuredImageChanged', this.existingFiles.concat(this.newFiles));
      }
    },
    async uploadFiles() {
      const promises = [];
      for (let i = 0; i < this.newFiles.length; i++) {
        promises.push(this.uploadFile(this.newFiles[i]));
      }
      const newFilesToReturn = await Promise.all(promises);
      this.$emit('updateFiles', this.existingFiles.concat(newFilesToReturn));
      this.newFiles = []; // now the new files have been uploaded we need to not display them as new anymore
    },
    async uploadFile(file) {
      const fileObj = {
        name: file.name,
        type: file.type,
        domainType: this.type,
        image_name: file.image_name,
        description: file.description,
        featured: file.featured,
      };

      let response = null;
      if (fileObj.featured === true) {
        this.existingFiles.map((x) => {
          x.featured = false;
          return x;
        });
      }
      response = await axios.post(`${process.env.VUE_APP_API_ROOT}/misc/getUrlForUpload`, JSON.stringify(fileObj));

      try {
        // eslint-disable-next-line
        delete axios.defaults.headers.common['Authorization'];

        const options = {
          headers: {
            'Content-Type': file.type,
          },
        };

        await axios.put(response.data.url, file.rawFile, options);

        // have to add back the authorization header
        axios.defaults.headers.common.Authorization = this.$store.state.auth.user.tokens.IdToken;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }

      return {
        image: `${response.data.photo.image}`,
        image_name: file.image_name,
        description: file.description,
        featured: file.featured,
        _id: response.data.photo.id,
      };
    },
  },
};
</script>

<style scoped>
.bold-text {
  font-weight: bold;
}
.upload-area {
  border: #4e97b2 dashed 1px;
  font-size: 14px;
  text-align: center;
  padding: 20px 0;
  margin-top: 30px;
}
.upload-icon {
  vertical-align: middle;
  margin-left: 15px;
  margin-right: 15px;
  color: white;
  stroke: black;
  stroke-width: 0.8rem;
}
::-webkit-file-upload-button {
  background-color: white;
}
.file-wrapper {
  -webkit-box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.08);
  box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: var(--rounded-xl);
}
.file-wrapper:hover {
  -webkit-box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.18);
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.18);
  border-radius: var(--rounded-xl);
}
.file-wrapper img {
  border-radius: var(--rounded-xl) var(--rounded-xl) 0 0;
}
.file-content {
  margin: 20px;
  font-size: 14px;
}
.file-content span {
  margin-top: 10px;
  display: block;
}
.featured {
  width: 50%;
  display: inline-block;
  padding: 20px 0;
}
a.remove {
  width: 100%;
  text-align: right;
  display: inline-block;
  margin-bottom: 10px;
  color: #666;
}
textarea {
  margin-bottom: 5px;
}
.red {
  color: #dc3545;
}
.char-counter {
  display: block;
  text-align: right;
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
}
</style>
